import React from 'react';
import {StyleSheet, Text, View, Image, ImageSourcePropType} from 'react-native';
import {colors} from 'src/assets';

export type LeftMessageProps = {
  text?: string;
  imageSource?: ImageSourcePropType;
  time?: string;
};

export const LeftMessage: React.FC<LeftMessageProps> = ({
  text,
  imageSource,
  time,
}) => {
  return (
    <View style={leftMessageStyles.root}>
      {time && <Text style={leftMessageStyles.time}>{time}</Text>}
      <View style={leftMessageStyles.content}>
        {text ? (
          <Text selectable style={leftMessageStyles.text}>
            {text}
          </Text>
        ) : null}
        {imageSource ? (
          <Image
            style={leftMessageStyles.image}
            source={imageSource}
            resizeMode={'cover'}
          />
        ) : null}
        <View style={leftMessageStyles.tail} />
      </View>
    </View>
  );
};

export type RightMessageProps = LeftMessageProps;

export const RightMessage: React.FC<RightMessageProps> = ({
  text,
  imageSource,
  time,
}) => {
  return (
    <View style={rightMessageStyles.root}>
      {time ? (
        <Text style={rightMessageStyles.time}>{time}</Text>
      ) : (
        <Text style={rightMessageStyles.time}>送信中</Text>
      )}
      <View style={rightMessageStyles.content}>
        {text ? (
          <Text selectable style={rightMessageStyles.text}>
            {text}
          </Text>
        ) : null}
        {imageSource ? (
          <Image
            style={rightMessageStyles.image}
            source={imageSource}
            resizeMode={'cover'}
          />
        ) : null}
        <View style={rightMessageStyles.tail} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
  content: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 4,
    marginVertical: 4,
  },
  tail: {
    position: 'absolute',
    bottom: 7,
  },
  text: {
    fontSize: 16,
    color: colors.black,
  },
  image: {width: 200, height: 150},
});

const leftMessageStyles = StyleSheet.create({
  root: {
    ...styles.root,
    alignItems: 'flex-start',
    marginRight: 16,
  },
  content: {
    ...styles.content,
    backgroundColor: '#DFF8F8',
    marginLeft: 20,
  },
  tail: {
    ...styles.tail,
    left: -10,
    borderLeftWidth: 10,
    borderTopWidth: 5,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderLeftColor: 'transparent',
    borderTopColor: '#DFF8F8',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
  },
  text: {
    ...styles.text,
  },
  image: {
    ...styles.image,
  },
  time: {
    fontSize: 12,
    fontWeight: '500',
    color: colors.chokuGray,
    marginBottom: 4,
    marginLeft: 20,
  },
});

const rightMessageStyles = StyleSheet.create({
  root: {
    ...styles.root,
    alignItems: 'flex-end',
    marginLeft: 16,
  },
  content: {
    ...styles.content,
    backgroundColor: '#F3F3F3',
    marginRight: 20,
    marginVertical: 0,
    marginBottom: 12,
  },
  tail: {
    ...styles.tail,
    right: -10,
    borderRightWidth: 10,
    borderTopWidth: 5,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    borderRightColor: 'transparent',
    borderTopColor: '#F3F3F3',
    borderLeftColor: 'transparent',
    borderBottomColor: 'transparent',
  },
  text: {
    ...styles.text,
  },
  image: {
    ...styles.image,
  },
  time: {
    fontSize: 12,
    fontWeight: '500',
    color: colors.chokuGray,
    marginBottom: 4,
    marginRight: 20,
  },
});
